var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H34C41.732 0 48 6.26801 48 14V34C48 41.732 41.732 48 34 48H14C6.26801 48 0 41.732 0 34V14Z",
    fill: "#13C296"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5085 26.0633C30.2236 26.3407 30.0927 26.7419 30.1576 27.1354L31.1354 32.5729C31.2179 33.0338 31.0243 33.5002 30.6405 33.7665C30.2643 34.0428 29.7639 34.076 29.3536 33.8549L24.4824 31.3019C24.313 31.2113 24.1249 31.1627 23.9324 31.1572H23.6344C23.531 31.1726 23.4298 31.2058 23.3374 31.2566L18.465 33.8218C18.2242 33.9433 17.9514 33.9864 17.6842 33.9433C17.033 33.8196 16.5986 33.1962 16.7053 32.5386L17.6842 27.1011C17.749 26.7043 17.6182 26.301 17.3333 26.0191L13.3617 22.151C13.0296 21.8271 12.9141 21.3409 13.0659 20.9021C13.2132 20.4644 13.5894 20.145 14.0436 20.0732L19.5099 19.2764C19.9257 19.2333 20.2908 18.9791 20.4778 18.6033L22.8865 13.641C22.9437 13.5305 23.0174 13.4288 23.1064 13.3426L23.2054 13.2652C23.2571 13.2078 23.3165 13.1603 23.3825 13.1216L23.5024 13.0774L23.6894 13H24.1524C24.566 13.0431 24.93 13.2918 25.1203 13.6631L27.5609 18.6033C27.7368 18.9647 28.0789 19.2156 28.4737 19.2764L33.94 20.0732C34.402 20.1395 34.788 20.46 34.9409 20.9021C35.085 21.3453 34.9607 21.8316 34.6219 22.151L30.5085 26.0633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.e13b309c2c3e7225a1100749eb29f6e4.svg";
export { ForwardRef as ReactComponent };